import React from 'react';
import PropTypes from 'prop-types';
/* styles */
import './form-error-message.scss';

class FormErrorMessage extends React.PureComponent {
  render() {
    return <div className="glu-form-error">{this.props.children}</div>;
  }
}

FormErrorMessage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormErrorMessage;
